'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../styleInject.js');

var css_248z = ".SuccessBanner-module_success__e0CHF{background:rgba(61,169,123,.1);border:1px solid #3da97b;border-radius:4px;box-sizing:border-box;color:#000;font-size:14px;line-height:20px;padding:16px;text-align:left}";
var styles = {"success":"SuccessBanner-module_success__e0CHF"};
styleInject["default"](css_248z, 'a3a760ba-ca3e-4bdc-a7d3-f8e3a5d9f7e5');

exports["default"] = styles;
